import { useQueryClient, useMutation } from "@tanstack/react-query";
import api from "@/lib/api-client";
import { toast } from "react-toastify";

const updateClinician = async (data) => {
    const payload = {
        ...data,
        credentially_OK:
            data.credentially_OK === 2 ? 2 : data.credentially_OK ? 1 : 0,
    };

    const res = await api.patch(`/Clinician`, payload);

    return res.data;
};

export const useUpdateClinician = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateClinician,
        retry: 1,
        onMutate: (vars) => vars,
        onSuccess: async (_, vars) => {
            await queryClient.invalidateQueries({
                queryKey: ["clinician"],
            });

            if (vars.credentially_OK === 2) {
                toast.success("Resent credentially email");
            } else {
                toast.success("Profile successfully updated");
            }
        },
        onError: async (_, vars) => {
            if (vars.credentially_OK === 2) {
                toast.error("Error sending credentially email");
            } else {
                toast.error("Error updating profile");
            }
        },
    });
};
